// BoundaryControl Preact component for region/department layer toggles

import { Signal } from '@preact/signals';
import { Panel } from './Panel';
import { panelBody } from './panel';
import { BoundaryOption } from './boundary';

interface BoundaryControlProps {
  regionsEnabled: Signal<boolean>;
  departmentsEnabled: Signal<boolean>;
  onRegionToggle: (enabled: boolean) => void;
  onDepartmentToggle: (enabled: boolean) => void;
}

/**
 * BoundaryControl component for administrative boundary layer toggles
 */
export function BoundaryControl({
  regionsEnabled,
  departmentsEnabled,
  onRegionToggle,
  onDepartmentToggle,
}: BoundaryControlProps) {
  return (
    <Panel id="boundary-control" title="🗺️ Limites administratives">
      <div className={panelBody}>
        <BoundaryOption
          id="boundary-region"
          label="Régions"
          checked={regionsEnabled.value}
          onChange={onRegionToggle}
        />
        <BoundaryOption
          id="boundary-department"
          label="Départements"
          checked={departmentsEnabled.value}
          onChange={onDepartmentToggle}
        />
      </div>
    </Panel>
  );
}
